import React from 'react';
import { Helmet } from 'react-helmet-async';
import Breadcrumb from './Breadcrumb';

/**
 * Combined page title (Helmet) + breadcrumb header.
 * @param {string} title - Document title (suffix after baseTitle)
 * @param {Array} breadcrumbItems - [{ label, href? }, ...]. Last item is current (no href).
 * @param {string} [baseTitle='LHRC ERP'] - Prefix for document title
 * @param {string} [className] - Extra class for the header wrapper
 * @param {ReactNode} [actions] - Optional actions slot rendered on the right side of the header
 */
function PageHeader({ title, breadcrumbItems = [], baseTitle = 'LHRC ERP', className = '', actions = null }) {
  const documentTitle = title ? `${baseTitle} | ${title}` : baseTitle;

  return (
    <>
      <Helmet>
        <title>{documentTitle}</title>
      </Helmet>
      <header className={`mb-6 ${className}`.trim()}>
        <div className="flex flex-wrap items-center justify-between gap-3">
          <Breadcrumb items={breadcrumbItems} />
          {actions ? <div className="shrink-0">{actions}</div> : null}
        </div>
      </header>
    </>
  );
}

export default PageHeader;
